import React, { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../Firebase';
import JitsiMeet from './JitsiMeet';
import QuestionSystem from './QuestionSystem';

// Export individual components for external use
export { JitsiMeet, QuestionSystem };

// JAAS Configuration
const JAAS_CONFIG = {
  appId: 'vpaas-magic-cookie-341df2792efa42deb9c109658698a253',
  domain: '8x8.vc'
};

// Main Competition Component that combines both systems
const Competition = ({ config = {}, onReturn }) => {
  const [meetingId, setMeetingId] = useState('');
  const [userName, setUserName] = useState('');
  const [meetLink, setMeetLink] = useState('');
  const [showJitsiMeet, setShowJitsiMeet] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  // ยกเลิกการขอ JWT ฝั่ง client: ให้ frontend ใช้ backend สร้าง JWT แทน

  // ฟังก์ชันสำหรับสร้าง JAAS URL
  const generateJAASURL = async (roomName, userName = '') => {
    // รวม tenant (appId) ใน path และปล่อยให้ JitsiMeet ดึง JWT จาก backend เอง
    const baseUrl = `https://8x8.vc/${JAAS_CONFIG.appId}/${roomName}`;
    if (userName) {
      const encodedName = encodeURIComponent(userName);
      return `${baseUrl}#config.startAudioOnly=false&config.prejoinPageEnabled=false&config.startWithAudioMuted=false&config.startWithVideoMuted=false&config.enableWelcomePage=false&config.enableClosePage=false&config.requireDisplayName=false&userInfo.displayName=${encodedName}`;
    }
    return baseUrl;
  };

  // เริ่มต้นการประชุมอัตโนมัติเมื่อ Component โหลด
  useEffect(() => {
    const initializeMeeting = async () => {
      setIsLoading(true);
      try {
        // ใช้ข้อมูลจาก config หรือ Firebase
        let meetingId = config.defaultMeetingId || '';
        let fullName = config.defaultUserName || '';

        // ถ้าไม่มีข้อมูลใน config ให้ดึงจาก Firebase
        if (!meetingId || !fullName) {
          const docRef = doc(db, 'Competition-Training', 'nathadaj', 'PowerWisdom@ห้องสอบ1', 'nathadaj');
          const docSnap = await getDoc(docRef);
          
          if (docSnap.exists()) {
            const data = docSnap.data();
            console.log('Firebase data:', data);
            
            // ดึง MeetingID (ลำดับความสำคัญ: MeetingID > Room1 > link > meetingID)
            meetingId = data.MeetingID || data.Room1 || data.link || data.meetingID || meetingId;
            
            // ดึงชื่อผู้ใช้
            const name = data.name || '';
            const surname = data.surname || '';
            fullName = `${name} ${surname}`.trim() || fullName;
          }
        }

        // ถ้ายังไม่มีข้อมูล ใช้ข้อมูล fallback
        if (!meetingId) {
          meetingId = 'PowerWisdom-ห้องสอบ1';
        }
        if (!fullName) {
          fullName = 'Nathadaj Apriwutkanjanapa';
        }

        console.log('Meeting ID:', meetingId);
        console.log('Full Name:', fullName);
        
        setMeetingId(meetingId);
        setUserName(fullName);
        
        // สร้าง JAAS URL จาก MeetingID
        const jaasUrl = await generateJAASURL(meetingId, fullName);
        console.log('Final JAAS URL:', jaasUrl);
        setMeetLink(jaasUrl);
        setShowJitsiMeet(true);

      } catch (error) {
        console.error('Error fetching data:', error);
        setError('เกิดข้อผิดพลาดในการดึงข้อมูล: ' + error.message);
        
        // ใช้ข้อมูล fallback เมื่อเกิดข้อผิดพลาด
        const fallbackId = 'PowerWisdom-ห้องสอบ1';
        const fallbackUserName = 'Nathadaj Apriwutkanjanapa';
        setMeetingId(fallbackId);
        setUserName(fallbackUserName);
        
        const fallbackUrl = await generateJAASURL(fallbackId, fallbackUserName);
        setMeetLink(fallbackUrl);
        setUserName(fallbackUserName);
        setShowJitsiMeet(true);
      } finally {
        setIsLoading(false);
      }
    };

    initializeMeeting();
  }, [config]);

  return (
    <div className="competition-container">
      {isLoading && (
        <div className="loading">
          <p>กำลังโหลดข้อมูล...</p>
        </div>
      )}

      {error && (
        <div className="error">
          <p>{error}</p>
          <button onClick={() => setError('')}>ปิด</button>
        </div>
      )}

      {showJitsiMeet && meetLink && (
        <div className="meeting-container">
          <JitsiMeet 
            meetLink={meetLink} 
            userName={userName}
            userId={`user-${Math.random().toString(36).slice(2,8)}`}
            userRole={'admin'}
            onExit={onReturn}
            onError={(error) => setError(error)}
          />
        </div>
      )}
    </div>
  );
};

// Default export is the main Competition component
export default Competition;
